import { Component, OnInit } from '@angular/core';
import { CognitoService } from './services/cognito/cognito.service';
import { RouterModule, Router, RouterEvent } from '@angular/router';
import { Location } from '@angular/common';
import { AppRoutingService } from './services/app-routing.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterModule],
  providers: [
    AppRoutingService,
    CognitoService,
  ]
})
export class AppComponent implements OnInit {
  title = 'app';

  public showLogout: boolean | undefined;

  constructor(
    private routingService: AppRoutingService,
    public cognitoService: CognitoService,
    private router: Router, public location: Location) {
    // @ts-ignore
    this.router.events.pipe(filter(e => e instanceof RouterEvent)).subscribe((val: RouterEvent) => {
      // if(val && val.url && val.url.indexOf('code') > -1) {
      //   const code = val.url.split('code=')[1].split('&')[0];
      //   console.log('--------code-----------', code);
      //   this.cognitoService.handleRedirectCallback(code);
      // }
      if (val && val.url && val.url.indexOf('id_token') > -1) {
        const id_token = val.url.split('id_token=')[1].split('&')[0];
        this.cognitoService.authenticateWithIdToken(id_token);
        this.router.navigate(['']);
      }
      this.showLogout = this.cognitoService.isAuthenticated();
    });
  }


  ngOnInit() {
    console.log('AppComponent ngOnInit');
    this.routingService.loadRouting();
    window.scroll(0, 0);
    if (!this.cognitoService.isAuthenticated() && !this.cognitoService.isFinalizingLogin()) {
      this.cognitoService.authAzure();
    }
  }


  onActivate(event: any) {
    console.log('onActivate', event);
    window.scroll(0, 0);
    if (!this.cognitoService.isAuthenticated() && !this.cognitoService.isFinalizingLogin()) {
      this.cognitoService.authAzure();
    }
  }

  logout() {
    this.cognitoService.logout();
    this.router.navigate(['/']);
  }
}
